module.exports = __webpack_public_path__ + "assets/img/media_2.3522fc1e.png";